import { Route, Routes } from "react-router-dom";
import AppLayout from "../../components/AppLayout";
import Entry from "../pages/Entry";
import { PAGE_NAME } from "../../types";
import OnboardingSignInPage from "../pages/onboarding/OnboardingSignInPage";
import { useState } from "react";
import i18n from "../i18n";
import HomePage from "../pages/home/HomePage";
import useThemeHook from "../hooks/useThemeHook";
import { useTranslationHook } from "../hooks/useTranslationHook";
import StakePage from "../pages/stake/StakePage";
import StakeSomePiPage from "../pages/stakeSomePi/StakeSomePiPage";
import ProfilePage from "../pages/profile/ProfilePage";
import ClaimGrantPage from "../pages/claimGrant/ClaimGrantPage";
import HistoryPage from "../pages/history/HistoryPage";
import SendCryptoPage from "../pages/sendCrypto/SendCryptoPage";
import ReceiveCryptoPage from "../pages/receiveCrypto/ReceiveCryptoPage";
import InviteUsersPage from "../pages/inviteUsers/InviteUsersPage";
import EmailVerificationPage from "../pages/emailVerification/EmailVerificationPage";
import WalletPage from "../pages/wallet/WalletPage";
import ExplorerPage from "../pages/explorer/ExplorerPage";
import ReferralsPage from "../pages/referrals/ReferralsPage";
import CryptoViewPage from "../pages/cryptoView/CryptoViewPage";
import SwapPage from "../pages/swap/SwapPage";
import DepositPage from "../pages/depositPage/DepositPage";
import LuckySpinPage from "../pages/luckySpin/LuckySpinPage";
import ProPage from "../pages/pro/ProPage";
import LeaderboardPage from "../pages/leaderboard/LeaderboardPage";
import NotificationsPage from "../pages/NotificationsPage";
import LoginPage from "../pages/login/LoginPage";
import AuthRoute from "../../components/AuthRoute";
import RewardsPage from "../pages/rewards/RewardsPage";
import SettingsPage from "../pages/settings/SettingsPage";
import InviteHandler from "../pages/inviteUsers/InviteHandler";
import TermsOfServicePage from "../pages/legal/TermsOfServicePage";
import PrivacyPolicyPage from "../pages/legal/PrivacyPolicyPage";
import TreasureVaultPage from "../pages/treasureVault/TreasureVaultPage";
import ForgePage from "../pages/forge/ForgePage";
import MysteryBoxPage from "../pages/mysteryBox/MysteryBoxPage";
import GamesPage from "../pages/games/GamesPage";
import TapRushGame from "../pages/games/TapRushGame";
import MemoryMatchGame from "../pages/games/MemoryMatchGame";
import NumberCrunchGame from "../pages/games/NumberCrunchGame";
import CryptoQuizGame from "../pages/games/CryptoQuizGame";
import WatchAndEarnPage from "../pages/watchAndEarn/WatchAndEarnPage";
import CommunityChatPage from "../pages/chat/CommunityChatPage";

export default function RouterPage() {
  const [locale, setLocale] = useState(i18n.language);
  const theme = useThemeHook();
  const getTranslationText = useTranslationHook();
  i18n.on("languageChanged", (lng) => setLocale(i18n.language));

  return (
    <Routes>
      <Route path="/" element={<Entry />} />
      <Route path={PAGE_NAME.LOGIN} element={<LoginPage />} />
      <Route path={PAGE_NAME.TERMS_OF_SERVICE} element={<TermsOfServicePage />} />
      <Route path={PAGE_NAME.PRIVACY_POLICY} element={<PrivacyPolicyPage />} />
      <Route
        path={PAGE_NAME.DEPOSIT}
        element={
          <AuthRoute>
            <DepositPage />
          </AuthRoute>
        }
      />
      <Route
        path={PAGE_NAME.EXPLORER}
        element={
          <AuthRoute>
            <ExplorerPage />
          </AuthRoute>
        }
      />
      <Route
        path={PAGE_NAME.ONBOARDING_SIGN}
        element={<OnboardingSignInPage />}
      />
      <Route
        path={PAGE_NAME.REFERRALS}
        element={
          <AuthRoute>
            <ReferralsPage />
          </AuthRoute>
        }
      />
      <Route
        path={PAGE_NAME.HOME}
        element={<HomePage />}
      />
      <Route
        path={PAGE_NAME.STAKE}
        element={
          <AuthRoute>
            <StakePage />
          </AuthRoute>
        }
      />
      <Route
        path={PAGE_NAME.TREASURE_VAULT}
        element={
          <AuthRoute>
            <TreasureVaultPage />
          </AuthRoute>
        }
      />
      <Route
        path={PAGE_NAME.FORGE}
        element={
          <AuthRoute>
            <ForgePage />
          </AuthRoute>
        }
      />
      <Route
        path={PAGE_NAME.MYSTERY_BOX}
        element={
          <AuthRoute>
            <MysteryBoxPage />
          </AuthRoute>
        }
      />
      <Route
        path={PAGE_NAME.GAMES}
        element={
          <AuthRoute>
            <GamesPage />
          </AuthRoute>
        }
      />
      <Route
        path={PAGE_NAME.TAP_RUSH}
        element={
          <AuthRoute>
            <TapRushGame />
          </AuthRoute>
        }
      />
      <Route
        path={PAGE_NAME.MEMORY_MATCH}
        element={
          <AuthRoute>
            <MemoryMatchGame />
          </AuthRoute>
        }
      />
      <Route
        path={PAGE_NAME.NUMBER_CRUNCH}
        element={
          <AuthRoute>
            <NumberCrunchGame />
          </AuthRoute>
        }
      />
      <Route
        path={PAGE_NAME.CRYPTO_QUIZ}
        element={
          <AuthRoute>
            <CryptoQuizGame />
          </AuthRoute>
        }
      />
      <Route
        path={PAGE_NAME.COMMUNITY_CHAT}
        element={
          <AuthRoute>
            <CommunityChatPage />
          </AuthRoute>
        }
      />
      <Route
        path={PAGE_NAME.STAKE_SOME_PI}
        element={
          <AuthRoute>
            <StakeSomePiPage />{" "}
          </AuthRoute>
        }
      />

      <Route
        path={PAGE_NAME.NOTIFICATIONS}
        element={
          <AuthRoute>
            <NotificationsPage />{" "}
          </AuthRoute>
        }
      />
      <Route
        path={PAGE_NAME.PROFILE}
        element={
          <AuthRoute>
            <ProfilePage />{" "}
          </AuthRoute>
        }
      />
      <Route
        path={PAGE_NAME.WALLET}
        element={
          <AuthRoute>
            <WalletPage />{" "}
          </AuthRoute>
        }
      />
      <Route
        path={PAGE_NAME.CLAIM_GRANT}
        element={
          <AuthRoute>
            <ClaimGrantPage />{" "}
          </AuthRoute>
        }
      />
      <Route
        path={PAGE_NAME.VERIFY_EMAIL}
        element={<EmailVerificationPage />}
      />
      <Route
        path={PAGE_NAME.HYSTORY_PAGE}
        element={
          <AuthRoute>
            <HistoryPage />{" "}
          </AuthRoute>
        }
      />
      <Route
        path={PAGE_NAME.SEND_CRYPTO}
        element={
          <AuthRoute>
            <SendCryptoPage />{" "}
          </AuthRoute>
        }
      />
      <Route path={PAGE_NAME.INVITE_USERS} element={<InviteUsersPage />} />
      <Route path="/invite/:code" element={<InviteHandler />} />
      <Route
        path={PAGE_NAME.CRYPTO_VIEW_PAGE}
        element={
          <AuthRoute>
            <CryptoViewPage />{" "}
          </AuthRoute>
        }
      />
      <Route
        path={PAGE_NAME.SWAP}
        element={
          <AuthRoute>
            <SwapPage />{" "}
          </AuthRoute>
        }
      />
      <Route
        path={PAGE_NAME.RECEIVE_CRYPTO}
        element={
          <AuthRoute>
            <ReceiveCryptoPage />{" "}
          </AuthRoute>
        }
      />
      <Route
        path={PAGE_NAME.REWARDS}
        element={
          <AuthRoute>
            <RewardsPage />
          </AuthRoute>
        }
      />
      <Route
        path={PAGE_NAME.SETTINGS}
        element={
          <AuthRoute>
            <SettingsPage />
          </AuthRoute>
        }
      />
      <Route
        path={PAGE_NAME.LUCKY_SPIN}
        element={
          <AuthRoute>
            <LuckySpinPage />
          </AuthRoute>
        }
      />
      <Route
        path={PAGE_NAME.PRO}
        element={
          <AuthRoute>
            <ProPage />
          </AuthRoute>
        }
      />
      <Route
        path={PAGE_NAME.LEADERBOARD}
        element={
          <AuthRoute>
            <LeaderboardPage />
          </AuthRoute>
        }
      />
      <Route
        path={PAGE_NAME.WATCH_AND_EARN}
        element={
          <AuthRoute>
            <WatchAndEarnPage />
          </AuthRoute>
        }
      />
    </Routes>
  );
}
